module.exports = __webpack_public_path__ + "img/SES_235425000.56f23425.jpg";